import { JSError } from './JSError';
import type { TJSErrorParams } from './const';
import { ObjectError } from './ObjectError';

type TServerErrorExtras = {
  status: number;
};

export class ServerError extends JSError<TServerErrorExtras> {
  static readonly coerce = coerceToServerError;

  constructor(params: Omit<TJSErrorParams<TServerErrorExtras>, 'name'>) {
    super({
      ...params,
      name: 'ServerError',
    });
  }
}

function coerceToServerError(normalized: JSError) {
  if (normalized instanceof ServerError) {
    return normalized;
  }

  if (normalized instanceof ObjectError) {
    return new ServerError({
      scope: normalized.scope,
      message: normalized._message,
      parent: normalized,
      shouldSkipLogs: normalized.shouldSkipLogs,
      status: 400,
    });
  }

  return new ServerError({
    scope: normalized.scope,
    message: normalized._message,
    parent: normalized,
    shouldSkipLogs: normalized.shouldSkipLogs,
    status: 500,
  });
}
